import * as actions from "../common/actions";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import SelectFilterField from "../components/SelectFilterField";

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (field: string, value: string, uiValue?: boolean) => {
      if (uiValue) {
        dispatch(actions.updateUi(field, value));
      } else {
        dispatch(actions.updateFilter(field, value));
      }
      dispatch(actions.updatePagination("pageNumber", 1));
      dispatch(actions.searchPush());
    },
  };
}

export default connect(null, mapDispatchToProps)(SelectFilterField);
